import { BaseApi } from './BaseApi';
import { CancelToken } from 'axios';

export default class StateProvinces extends BaseApi {
  public async getAllAsync(cancelToken?: CancelToken) {
    return await this.getListAsync<IStateProvince>('stateprovinces', null, cancelToken);
  }
}
